import ContentBlock from "@/components/content-block";
import dynamicLocalization from "@/mixins/dynamic-localization";
import standardRequest from "@/mixins/request/standard";
import guestRequest from "@/mixins/request/guest";

export default {
  mixins: [dynamicLocalization, standardRequest, guestRequest],
  components: { ContentBlock },
  data() {
    return {
      albums: [],
    };
  },
  mounted() {
    this.loadAlbums();
  },
  methods: {
    loadAlbums() {
      this.standardRequest("GET", `gallery`, (res) => {
        this.albums = res.data;
      });
    },
  },
};
